import {Component, Input} from '@angular/core';

/**
 * Renders a miniature document page that shows how an image gets placed in the
 * document view and the pdf export. Makes the effect of the width and alignment
 * options visible while they are edited (MYM-1043).
 */
@Component({
  selector: 'app-qa-image-display-preview',
  templateUrl: './image-display-preview.component.html',
  styleUrls: ['./image-display-preview.component.css']
})
export class ImageDisplayPreviewComponent {
  /**
   * Image width in percent of the page width. Falls back to this width if none is set
   */
  private static readonly DEFAULT_WIDTH_PERCENT = 50;

  /**
   * Image width in percent of the page width. May be null or undefined
   */
  @Input() widthPercent: number;

  /**
   * Image alignment on the page. One of "left", "center" or "right"
   */
  @Input() alignment = 'left';

  /**
   * Stretches the image over the full page width
   */
  @Input() fullWidth: boolean;

  /**
   * Url of the image to show. Renders a placeholder box if not set
   */
  @Input() imageUrl: string;

  /**
   * Returns the inline styles for the previewed image, so it mirrors the width and
   * the alignment that the document view and the pdf export apply. Alignment is done
   * via margins, just like in the rendered document
   *
   * @returns {{[key: string]: string}}
   */
  public getImageStyle(): {[key: string]: string} {
    const percent = this.widthPercent || ImageDisplayPreviewComponent.DEFAULT_WIDTH_PERCENT;
    const style: {[key: string]: string} = {width: this.fullWidth ? '100%' : `${percent}%`};

    if (this.alignment === 'center') {
      style['margin-left'] = 'auto';
      style['margin-right'] = 'auto';
    }

    if (this.alignment === 'right') {
      style['margin-left'] = 'auto';
    }

    return style;
  }
}
